<template>
  <button :disabled="isDisabled" class="button-helper" :style="style">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'circle-button',
  props: {
    background: {
      type: String,
      default: '#ffffff',
      required: false
    },
    color: {
      type: String,
      default: '#02B061',
      required: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      return `color: ${this.color};background: ${this.background};`
    }
  }
}
</script>

<style scoped>
.button-helper {
  border-radius: 50%;
  padding: 10px 20px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  box-shadow: 0px 4px 20px rgba(133, 135, 142, 0.5);
    z-index: 10;
}
.button-helper:disabled{
  background: rgb(206, 184, 184) !important;
}
</style>
